import { createApp } from 'vue';
import { createPinia } from 'pinia';

// Vue components
import ContactForm from '@/frontend/vue/components/Forms/ContactForm.vue';
import SubscribeForm from '@/frontend/vue/components/Forms/SubscribeForm.vue';
import HeaderSearch from '@/frontend/vue/components/Search/HeaderSearch.vue';

import CollectionFilters from '@/frontend/vue/components/Collection/CollectionFilters.vue';
import CollectionList from '@/frontend/vue/components/Collection/CollectionList.vue';

import SpecialFilters from '@/frontend/vue/components/Specials/SpecialFilters.vue';
import SpecialList from '@/frontend/vue/components/Specials/SpecialList.vue';

import ProductList from '@/frontend/vue/components/Product/ProductList.vue';
import ProductVariations from '@/frontend/vue/components/Product/ProductVariations.vue';
import ProductFilters from '@/frontend/vue/components/Product/ProductFilters.vue';
import ProductGrids from '@/frontend/vue/components/Product/ProductGrids.vue';
import ProductCard from '@/frontend/vue/components/Product/ProductCard.vue';
import ProductNonStockPurchase from '@/frontend/vue/components/Product/ProductNonStockPurchase.vue';
import DeliveryAddressLookup from '@/frontend/vue/components/Product/DeliveryAddressLookup.vue';

import SideCart from '@/frontend/vue/components/Cart/SideCart.vue';
import CartCount from '@/frontend/vue/components/Cart/Count.vue';

import CheckoutView from '@/frontend/vue/components/Checkout/CheckoutView.vue';
import CheckoutDelivery from "@/frontend/vue/components/Checkout/CheckoutDelivery.vue";
import CheckoutCollect from "@/frontend/vue/components/Checkout/CheckoutCollect.vue";
import AddressRequiredModal from '@/frontend/vue/components/Modal/AddressRequiredModal.vue';
import CategoriesCarousel from '@/frontend/vue/components/Homepage/CategoriesCarousel.vue';

const pinia = createPinia();
const app = createApp({});

// Register all components globally
app.component('contact-form', ContactForm);
app.component('subscribe-form', SubscribeForm);
app.component('header-search', HeaderSearch);
app.component('collection-filters', CollectionFilters);
app.component('collection-list', CollectionList);
app.component('special-filters', SpecialFilters);
app.component('special-list', SpecialList);
app.component('product-grids', ProductGrids);
app.component('product-filters', ProductFilters);
app.component('product-list', ProductList);
app.component('product-card', ProductCard);
app.component('product-non-stock-purchase', ProductNonStockPurchase);
app.component('product-variations', ProductVariations);
app.component('delivery-address-lookup', DeliveryAddressLookup);
app.component('side-cart', SideCart);
app.component('cart-count', CartCount);
app.component('checkout-view', CheckoutView);
app.component('checkout-delivery', CheckoutDelivery);
app.component('checkout-collect', CheckoutCollect);
app.component('address-required-modal', AddressRequiredModal);
app.component('categories-carousel', CategoriesCarousel);

app.use(pinia);
app.mount('#app');

// For the magic auto-loader (dont remove this)
const components = {
    'contact-form': ContactForm,
    'subscribe-form': SubscribeForm,
    'header-search': HeaderSearch,
    'collection-filters': CollectionFilters,
    'collection-list': CollectionList,
    'special-filters': SpecialFilters,
    'special-list': SpecialList,
    'product-grids': ProductGrids,
    'product-filters': ProductFilters,
    'product-list': ProductList,
    'product-card': ProductCard,
    'product-non-stock-purchase': ProductNonStockPurchase,
    'product-variations': ProductVariations,
    'delivery-address-lookup': DeliveryAddressLookup,
    'side-cart': SideCart,
    'cart-count': CartCount,
    'checkout-view': CheckoutView,
    'checkout-delivery': CheckoutDelivery,
    'checkout-collect': CheckoutCollect,
    'address-required-modal': AddressRequiredModal,
    'categories-carousel': CategoriesCarousel,
};

const parsePropsFromDataset = (dataset) => {
    const props = {};
    for (const key of Object.keys(dataset)) {
        if (key === 'vue') continue;

        try {
            const val = dataset[key];

            // Smart parse: Try JSON if it starts with { or [
            if (val && (val.trim().startsWith('{') || val.trim().startsWith('['))) {
                props[key] = JSON.parse(val);
            } else {
                props[key] = val;
            }
        } catch (err) {
            console.warn(`Failed to parse prop ${key}:`, err);
            props[key] = dataset[key];
        }
    }
    return props;
};

app.autoMountDataVue = () => {
    document.querySelectorAll('[data-vue]').forEach((el) => {

        const tag = el.tagName.toLowerCase()
        const vue = el.dataset.vue;
        const name = tag === 'form' || tag === 'div' || tag === 'span' ? vue : tag;

        const component = components[name]

        if (!component) {
            console.warn(`Component "${name}" not found in component map.`)
            return
        }

        const props = parsePropsFromDataset(el.dataset)

        try {
            const subApp = createApp(component, props)
            subApp.use(pinia)
            subApp.mount(el)
            console.log(`✅ Mounted <${name}>`)
        } catch (err) {
            console.error(`💥 Failed to mount <${name}>`, err)
        }
    })
}

app.autoMountDataVue();
